import React, { useContext, useEffect, useRef, useState } from "react";

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Toast } from "primereact/toast";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Dropdown } from "primereact/dropdown";
import { InputMask } from "primereact/inputmask";
import { InputText } from "primereact/inputtext";
import { Calendar } from "primereact/calendar";
import { Checkbox } from "primereact/checkbox";
import { Button } from "primereact/button";
import { InputNumber } from "primereact/inputnumber";

// ------------------ COMPONENTES DE BASE--------------------------
import AgGrid from "../../../../../Base/Components/Tables/AgGrid/AgGrid";
import Card from "../../../../../Base/Components/Card/Card";
import { useForm } from "../../../../../Base/Hooks/useForm";
import { toastShow } from "../../../../../Base/Services/ToastService";
import { AuthContext } from "../../../../../Base/Context/AuthContext/AuthContext";
import Loader from "../../../../../Base/Components/Loader/Loader";

// ------------------- CONSULTAS A LA API---------------------------
import { getEstadosCategory } from "../../../../../API/Global/Status/StatusRequests";
import { getProveedor, getProveedorAct } from "../../../../../API/Compras/Proveedores/ProveedoresRequest";
import { 
  EditarProveedorCAI, GuardarProveedorCAI, 
  getProveedorCAIporVendor, getTiposCAI, CambiarProveedorCAI } from "../../../../../API/Compras/Proveedores/ProveedoresCAIRequest";

const CrudProveedoresCAI = ({
  idProveedorCAI,
  proveedorSeleccionado,
  actualizarProveedoresCAI,
  IdProveedor,
}) => {
  const { userAuth } = useContext(AuthContext);
  const toast = useRef(null);

  const [estados, setEstados] = useState([]);
  const [proveedorCAI, setProveedorCAI] = useState([]);
  const [proveedor, setProveedor] = useState([]);
  const [tiposCAI, setTiposCAI] = useState([]);
  const [loading, setLoading] = useState(false);
  const [habilitar, setHabilitar] = useState(false);
  const [tooltipText, setTooltipText] = useState("Copiar RTN");
  const [proveedores, setProveedores] = useState([]);
  const [crearCAI, setCrearCAI] = useState(false);

  const initialValues = {
    NombreSucursal: "",
    ProveedorInternacional: false,
    IdEstado: 5,
    StatusName: "Active",
    IdProveedorCAI: -1,
    NoCAI: null,
    Prefijo: null,
    RangoInicial: null,
    RangoFinal: null,
    FechaVencimiento: null,
    IdTipoCAI: 1,
  };

  const { values, setValues, handleInputChange, resetForm } = useForm(initialValues);
  const esEdicionCAI = Number(values?.IdProveedorCAI) > 0;

  const handleCopy = () => {
    if (proveedorSeleccionado?.RTN || proveedores?.RTN) {
      navigator.clipboard.writeText(proveedorSeleccionado?.RTN || proveedores?.RTN).then(() => {
        setTooltipText("RTN Copiado");
        setTimeout(() => setTooltipText("Copiar RTN"), 2000);
      });
    }
  };

  const handleChange = (checked, name) => {
    if (name === "ProveedorInternacional") {
      setHabilitar(checked);
    }
    setValues({ ...values, [name]: checked });
  };

  const getInfo = async () => {
    setLoading(true);

    const t = await getEstadosCategory("General");
    setEstados(t);

    const tipos = await getTiposCAI();
    setTiposCAI(tipos);

    const proveedorTempo = await getProveedor();
    const proveedoresActivos = await getProveedorAct();
    setProveedor(proveedoresActivos);

    const IdVendorActual =
      Number(IdProveedor) ||
      Number(proveedorSeleccionado?.IdVendor) ||
      Number(proveedorSeleccionado) ||
      null;

    if (IdVendorActual) {
      const proveedorTempo2 = proveedorTempo.find((i) => Number(i?.IdVendor) === Number(IdVendorActual));
      const estadoProveedor = t.find((estado) => Number(estado?.IdStatus) === Number(proveedorTempo2?.IdStatus));
      setProveedores(
        proveedorTempo2
          ? {
              ...proveedorTempo2,
              Background: estadoProveedor?.Background,
              Color: estadoProveedor?.Color,
            }
          : { IdVendor: IdVendorActual }
      );
      setCrearCAI(proveedorTempo2?.IdStatus ? Number(proveedorTempo2.IdStatus) !== 5 : false);

      const proveedorCAItempo = await getProveedorCAIporVendor(IdVendorActual);
      setProveedorCAI(proveedorCAItempo);
    } else {
      setProveedorCAI([]);
      setCrearCAI(false);
    }

    setLoading(false);
  };

  const informacionSucursal = (rowData) => {
    setValues({
      ...rowData,
      FechaVencimiento:
        rowData.FechaVencimiento === null
          ? null
          : new Date(rowData.FechaVencimiento),
    });
    setHabilitar(rowData.ProveedorInternacional ? true : false);
  };

  const dialogo = (rowData) => {
    return (
      <div>
        <span
          style={{ fontSize: 15 }}
          onDoubleClick={() => informacionSucursal(rowData)}
        >
          {rowData.NombreSucursal}{" "}
        </span>
      </div>
    );
  };

  const verificarCampos = () => {
    let err = false;

    const idProveedorCAIActual = Number(values?.IdProveedorCAI || 0);
    const idEstadoActual = Number(values?.IdEstado || 0);
    const noCAIActual = String(values?.NoCAI || "").trim();

    const normalizarPrefijo = (prefijo) => {
      return String(prefijo || "").trim().slice(0, 11);
    };  
    const prefijoActual = normalizarPrefijo(values?.Prefijo);

    const rangoInicialActual = Number(values?.RangoInicial || 0);
    const rangoFinalActual = Number(values?.RangoFinal || 0);

    if (!values.NombreSucursal) {
      err = true;
      toastShow(toast, "error", "Error", "Debe agregar un Nombre de Sucursal.");
    }

    if (!values.IdTipoCAI) {
      err = true;
      toastShow(toast, "error", "Error", "Debe seleccionar un Tipo CAI.");
    }

    if (values.ProveedorInternacional === false) {
      if (!values.NoCAI) {
        err = true;
        toastShow(toast, "error", "Error", "Debe agregar un Numero CAI.");
      }

      if (!values.Prefijo) {
        err = true;
        toastShow(toast, "error", "Error", "Debe agregar un Prefijo.");
      }

      if (!values.RangoInicial) {
        err = true;
        toastShow(toast, "error", "Error", "Debe agregar un Rango Inicial.");
      }

      if (!values.RangoFinal) {
        err = true;
        toastShow(toast, "error", "Error", "Debe agregar un Rango Final.");
      }

      if (!values.FechaVencimiento) {
        err = true;
        toastShow(toast, "error", "Error", "Debe agregar una Fecha de Vencimiento.");
      }

      if (values.RangoInicial && values.RangoFinal && rangoFinalActual <= rangoInicialActual) {
        err = true;
        toastShow(
          toast,
          "error",
          "Error",
          "El Rango Final debe ser mayor que el Rango Inicial."
        );
      }

      if (idEstadoActual !== 7) {
        const CAIIgual = proveedorCAI
          ?.filter((item) => Number(item?.IdProveedorCAI) !== idProveedorCAIActual && Number(item?.IdEstado) !== 7)
          ?.find((item) => String(item?.NoCAI || "").trim() === noCAIActual && normalizarPrefijo(item?.Prefijo) === prefijoActual);

        if (CAIIgual) {
          err = true;
          toastShow(
            toast,
            "error",
            "El CAI ingresado ya existe",
            "Ingrese un nuevo CAI."
          );
        }

        const rangoTraslapadoPorPrefijo = proveedorCAI?.filter((item) => Number(item?.IdProveedorCAI) !== idProveedorCAIActual && Number(item?.IdEstado) !== 7)?.find((item) => {
          const mismoPrefijo = normalizarPrefijo(item?.Prefijo) === prefijoActual;
          const rangoInicialExistente = Number(item?.RangoInicial || 0);
          const rangoFinalExistente = Number(item?.RangoFinal || 0);
          const rangoSeCruza = rangoInicialActual <= rangoFinalExistente && rangoFinalActual >= rangoInicialExistente;
          return mismoPrefijo && rangoSeCruza;
        });

        if (rangoTraslapadoPorPrefijo) {
          err = true;
          toastShow(
            toast,
            "error",
            "Rango traslapado",
            `Ya existe un CAI con el prefijo ${prefijoActual} en el rango ${rangoTraslapadoPorPrefijo.RangoInicial} - ${rangoTraslapadoPorPrefijo.RangoFinal}.`
          );
        }
      }
    }
    return !err;
  };

  const resetForm2 = () => {
    setValues({
      ...values,
      NoCAI: "",
      Prefijo: "",
      RangoInicial: null,
      RangoFinal: null,
      FechaVencimiento: null,
    });
  };

  const guardarInformacionProveedor = async () => {
    const verificar = verificarCampos();
    setLoading(true);

    if (verificar) {
      const IdVendorGuardar =
        Number(IdProveedor) || Number(proveedorSeleccionado?.IdVendor) ||
        Number(proveedorSeleccionado) || Number(proveedores?.IdVendor) || null;

      if (!IdVendorGuardar) {
        toastShow(
          toast,
          "error",
          "Error",
          "No se encontró el proveedor. Cierre el modal de CAI y seleccione nuevamente el proveedor."
        );
        setLoading(false);
        return;
      }

      const bodyEncabezado = {
        IdProveedorCAI: values?.IdProveedorCAI,
        IdVendor: IdVendorGuardar,
        NoCAI: values.ProveedorInternacional ? null : values.NoCAI,
        RangoInicial: values.ProveedorInternacional ? null : values.RangoInicial,
        RangoFinal: values.ProveedorInternacional ? null : values.RangoFinal,
        Prefijo: values.ProveedorInternacional ? null : values.Prefijo,
        FechaVencimiento: values.ProveedorInternacional ? null : values.FechaVencimiento,
        NombreSucursal: values.NombreSucursal,
        ProveedorInternacional: values.ProveedorInternacional,
        IdUserEdit: userAuth.IdUser,
        IdEstado: values.IdEstado,
        IdTipoCAI: values.IdTipoCAI,
      };

      if (bodyEncabezado.IdProveedorCAI > 0) {
        const respuesta = await EditarProveedorCAI(bodyEncabezado);

        if (respuesta[0].ESTADO === 1) {
          toastShow(toast,"success","Datos Editados","Proveedor CAI editado Correctamente");
          if(bodyEncabezado.ProveedorInternacional === true){
            resetForm2()
            actualizarProveedoresCAI();
          }
          actualizarProveedoresCAI();
          setLoading(false);
          getInfo();
          return true;
        } else {
          toastShow(toast, "error", "Error", "Error al editar Proveedor CAI");
        }
      } else {
        const respuesta = await GuardarProveedorCAI(bodyEncabezado);

        if (respuesta[0].ESTADO === 1) {
          toastShow(toast,"success","Datos Agregados",respuesta[0]?.MENSAJE);
          resetForm();
          actualizarProveedoresCAI();
          setLoading(false);
          getInfo();
          return true;
        } else {
          toastShow(toast, "error", 'Error', respuesta[0]?.MENSAJE);
        }
      }
    } else {
      // toastShow(toast, "error", "Error", "Llena los campos Requeridos");
      setLoading(false);
      return;
    }
    // setLoading(false);
  };

  const nuevoProveedor = () => {
    confirmDialog({
      message: "Esta seguro que desea crear un nuevo ProveedorCAI",
      header: "Cancelar",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Si",
      accept: () => {
        resetForm();
        setHabilitar(false);
      },
      rejectLabel: "No",
      style: { backgroundColor: "white" },
    });
  };

  const handleButtonClick = () => {
    window.open(`https://oficinavirtual.sar.gob.hn/fac/validador-doc-fiscales/`, '_blank');
  };

  const TemplateProveedor = (props) => {
    return (
      <Dropdown
        value={props?.data?.IdVendor}
        options={proveedor}
        optionValue="IdVendor"
        optionLabel="CustomerName"
        filter
        showClear={false}
        style={{ width: "100%" }}
        onChange={(e) => {
          CambiarProveedor(props?.data, e.value);
        }}
      />
    );
  };

  const CambiarProveedor = async (rowData, nuevoIdVendor) => {
    if (!rowData?.IdProveedorCAI || !nuevoIdVendor) {
      toastShow(
        toast,
        "error",
        "Error",
        "No se pudo obtener la información para cambiar el proveedor."
      );
      return;
    }

    const datosEnviar = {
      IdProveedorCAI: rowData.IdProveedorCAI,
      IdVendor: nuevoIdVendor,
      IdUserEdit: userAuth?.IdUser,
    };

    const result = await CambiarProveedorCAI(datosEnviar);

    if (result?.[0]?.ESTADO === 1 || result?.ESTADO === 1) {
      toastShow(
        toast,
        "success",
        "Proveedor actualizado",
        "El proveedor del CAI fue actualizado correctamente."
      );

      await getInfo();

      if (actualizarProveedoresCAI) {
        actualizarProveedoresCAI();
      }
    } else {
      toastShow(
        toast,
        "error",
        "Error",
        result?.[0]?.MENSAJE || result?.MENSAJE || "No se pudo cambiar el proveedor del CAI."
      );
    }
  };

  const columns = [
    {
      header: "ID",
      headerEn: "Date Create",
      field: "IdProveedorCAI",
      frozen: true,
      className: "XXsmall",
    },
    {
      header: "Nombre Sucursal",
      headerEn: "",
      field: "NombreSucursal",
      className: "Xlarge",
      Sumary: "count",
      Format: "Template",
      body: (rowData) => dialogo(rowData),
      frozen: true,
    },
    {
      header: "Estado",
      headerEn: "Status",
      field: "StatusName",
      className: "small",
      Format: "Estado",
      backgroundField: "Background",
      colorField: "Color",
      body: (rowData) => ({
        ID: rowData.IdEstado,
        Estado: rowData.StatusName,
      }),
    },
    {
      header: "Tipo CAI",
      headerEn: "CAI Type",
      field: "TipoCAI",
      className: "small",
    },
    {
      header: "Prefijo",
      headerEn: "",
      field: "Prefijo",
      className: "Xlarge",
    },
    {
      header: "No. CAI",
      headerEn: "No. CAI",
      field: "NoCAI",
      className: "Xlarge",
    },
    {
      header: "Rango Inicial",
      field: "RangoInicial",
      className: "medium",
    },
    {
      header: "Rango Final",
      field: "RangoFinal",
      className: "medium",
    },
    {
      header: "Fecha Vencimiento",
      field: "FechaVencimiento",
      Format: "Date",
    },
    {
      header: "Proveedor",
      headerEn: "",
      field: "CustomerName",
      className: "large",
      frozen: true,
      alignFrozen: "right",
      editable: ({ data }) => {
        if (Number(userAuth?.IdRol) === 1) {
          return true;
        }
        return false;
      },
      cellEditor: TemplateProveedor,
    },
  ];

  const table = {
    Columns: columns,
    Data: proveedorCAI,
  };

  useEffect(() => {
  getInfo();
}, [idProveedorCAI, IdProveedor, proveedorSeleccionado]);

  useEffect(() => {
    if (values.ProveedorInternacional) {
      resetForm2();
    }
  }, [values.ProveedorInternacional]);


  const RTNEmpresa = (proveedorSeleccionado?.RTN || proveedores?.RTN) &&  `- RTN: ${(proveedorSeleccionado?.RTN || proveedores?.RTN)}`

  return (
    <div id="Dialog">
      <Loader loading={loading} querySelector={"#Dialog"} />
      <Toast ref={toast} />
      <ConfirmDialog />
      <div className="d-flex align-items-center">
        <h2>
          Proveedor {proveedorSeleccionado?.CustomerName || proveedores?.CustomerName} {RTNEmpresa}
          {(proveedorSeleccionado?.RTN || proveedores?.RTN) && (
            <Button
              icon="pi pi-copy"
              className="p-button-text p-ml-2 mx-2"
              onClick={handleCopy}
              tooltip={tooltipText}
              tooltipOptions={{ position: "top" }}
            />
          )}

          {proveedores?.StatusName && (
            <Button
              label={proveedores.StatusName}
              style={{
                backgroundColor: proveedores?.Background,
                color: proveedores?.Color,
                width: 100,
                height: 35,
                marginLeft: 8,
                border: "none",
              }}
            />
          )}
        </h2>
      </div>

      <div>
        <div className="d-flex flex-row flex-wrap mb-4 gap-4">
          {/* NOMBRE SUCURSAL */}
          <div className="field mx-2">
            <span className="p-float-label">
              <InputText
                name="NombreProducto"
                value={values.NombreSucursal}
                onChange={(e) => handleInputChange(e, "NombreSucursal")}
                style={{ width: "42.3vw" }}
                disabled={crearCAI}
              />
              <label htmlFor="NombreProducto">Nombre Sucursal</label>
            </span>
          </div>

          {/* CHECKBOX PROVEEDOR INTERNACIONAL */}
          <div className="d-flex encabezado__contenido-Card flex-wrap justify-content-between">
            <span
              className="p-inputgroup encabezado__span-idEncabezado mt-2"
              style={{ marginLeft: 2 }}
            >
              <span
                className="p-float-label encabezado__boton-archivo"
                style={{ verticalAlign: "center" }}
              >
                <Checkbox
                  checked={values.ProveedorInternacional}
                  onChange={(e) => {
                    handleChange(e.checked, "ProveedorInternacional");
                  }}
                  disabled={crearCAI}
                />
                <span className="mx-2">Proveedor Internacional</span>
              </span>
            </span>
          </div>

          {/* TIPO CAI */}
          <div className="field">
            <span className="p-float-label">
              <Dropdown
                name="IdTipoCAI"
                value={values.IdTipoCAI}
                onChange={(e) => handleInputChange(e, "IdTipoCAI")}
                style={{ width: "24vh" }}
                options={tiposCAI}
                optionValue="IdTipoCAI"
                optionLabel="TipoCAI"
                disabled={crearCAI}
              />
              <label htmlFor="IdTipoCAI" className="ml-2">
                Tipo CAI
              </label>
            </span>
          </div>

          {/* ESTADO */}
          <div className="field">
            <span className="p-float-label">
              <Dropdown
                name="Estado"
                value={values.IdEstado}
                onChange={(e) => handleInputChange(e, "IdEstado")}
                style={{ width: "24vh" }}
                options={estados}
                optionValue="IdStatus"
                optionLabel="StatusName"
                disabled={crearCAI}
              />
              <label htmlFor="Estado" className="ml-2">
                Estado
              </label>
            </span>
          </div>
        </div>

        <div className="d-flex flex-row flex-wrap gap-4 mb-3">
          {/* NO.CAI */}
          <div className="field mx-2">
            <span className="p-float-label">
              <InputMask
                id="NoCAI"
                name="NoCAI"
                mask="******-******-******-******-******-**"
                value={values?.NoCAI || ""}
                placeholder="000000-000000-000000-000000-000000-00"
                autoClear={false}
                onChange={(e) => {
                  setValues((prevValues) => ({
                    ...prevValues,
                    NoCAI: e.target.value,
                  }));
                }}
                style={{ width: "22vw" }}
                disabled={
                  habilitar ||  (crearCAI && !esEdicionCAI)
                }
              />
              <label htmlFor="NoCAI">No. CAI</label>
            </span>
          </div>

          {/* PREFIJO */}
          <div className="field">
            <span className="p-float-label">
              <InputMask
                mask="999-999-99-?99999999"
                value={values.Prefijo}
                placeholder="999-999-99-999"
                onChange={(e) => handleInputChange(e, "Prefijo")}
                style={{ width: "100%" }}
                disabled={habilitar || crearCAI}
              />
              <label htmlFor="Prefijo">Prefijo</label>
            </span>
          </div>

          {/* RANGO INICIAL */}
          <div className="field">
            <span className="p-float-label">
              <InputNumber
                value={values.RangoInicial}
                useGrouping={false}
                onChange={(e) => handleInputChange(e, "RangoInicial")}
                disabled={habilitar || crearCAI}
              />
              <label htmlFor="RangoInicial">Rango Inicial</label>
            </span>
          </div>

          {/* RANGO FINAL */}
          <div className="field">
            <span className="p-float-label">
              <InputNumber
                value={values.RangoFinal}
                useGrouping={false}
                onChange={(e) => handleInputChange(e, "RangoFinal")}
                disabled={habilitar || crearCAI}
              />
              <label htmlFor="RangoInicial">Rango Final</label>
            </span>
          </div>

          {/* FECHA VENCIMIENTO */}
          <div className="field">
            <span className="p-float-label">
              {/* <Calendar
                inputId="FechaVencimiento"
                name="FechaVencimiento"
                value={values.FechaVencimiento}
                onChange={(e) =>
                  setValues({
                    ...values,
                    FechaVencimiento: e.value,
                  })
                }
                dateFormat="dd/mm/yy"
                mask="99/99/9999"
                showIcon
                showButtonBar
                disabled={habilitar || crearCAI}
                appendTo={document.body}
                baseZIndex={100000}
                autoZIndex={false}
                style={{ width: 230 }}
                inputStyle={{ width: "100%" }}
              /> */}
              <Calendar
                inputId="FechaVencimiento"
                name="FechaVencimiento"
                icon="pi pi-calendar"
                value={values?.FechaVencimiento}
                onChange={(e) =>
                  setValues({
                    ...values,
                    FechaVencimiento: e.value,
                  })
                }
                dateFormat="dd/mm/yy"
                showIcon
                showButtonBar
                disabled={habilitar || crearCAI}
              />
              <label htmlFor="FechaVencimiento">Fecha Vencimiento</label>
            </span>
          </div>
        </div>

        {/* BTN GUARDAR, NUEVO, CARGAR, VER-SAR */}
        <div>
          <Button
            onClick={() => guardarInformacionProveedor()}
            className="mx-2"
            icon="pi pi-save"
            tooltip="Guardar"
            tooltipOptions={{position: "top"}}
            disabled={crearCAI && !esEdicionCAI}
          />

          <Button
            icon="pi pi-book"
            type="button"
            onClick={() => nuevoProveedor()}
            tooltip="Nuevo"
            tooltipOptions={{position: "top"}}
            style={{ marginLeft: 1 }}
            disabled={crearCAI}
          />

          <Button
            icon="pi pi-sync"
            type="button"
            onClick={() => getInfo()}
            tooltip="Cargar"
            tooltipOptions={{position: "top"}}
            style={{ marginLeft: 8 }}
          />

          <Button
            onClick={handleButtonClick}
            // disabled={habilitar}
            icon="ri-verified-badge-line"
            tooltip="Verificador SAR"
            style={{ marginLeft: 8 }}
          />
        </div>
      </div>

      {/* TABLA */}
      <Card
        contenido={
          <div style={{ height: "50vh" }}>
            <AgGrid table={table} />
          </div>
        }
      />
    </div>
  );
};

export default CrudProveedoresCAI;
